/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import React, { useState, forwardRef } from 'react';
import HeaderText from 'components/HeaderText';

// import Tooltip from 'components/Tooltip';
// import Icon, { IconTypes } from 'components/Icon';
// import Button from 'components/Button';

import FormJSX from 'components/Form/FormJSX';
import FieldOption from 'components/Form/FieldOption';
import t from 'tcomb-validation';

import { buildUsStateEnum } from 'schemas/common/address';


function ExemptionForm({
  onChange
}, ref) {
  const [formState, setFormState] = useState();

  let schema = {
    exemptionType: t.enums.of([
      'No Exemption',
      'Publicly Traded US Entity via NASDAQ',
      'Publicly Traded US Entity via New York Stock Exchange (NYSE)',
      'Publicly Traded US Entity via American Stock Exchange (NYSE American)',
      'An insurance company regulated by a state',
      'A public accounting firm registered under section 102 of the Sarbanes-Oxley Act',
      'Financial Institution regulated by a Federal functional regulator or a bank regulated by a State bank regulator',
      'Sole Proprietor',
      'Unincorporated Association or Organization (informal associations, recreation or club accounts)',
      'Government Entity',
      'Estate',
      'Trust not formed by a state filing',
      'An issuer of securities registered with Securities Exchange Act (SEC)',
      'Bank holding company',
      'Pooled investment vehicle operated AND advised by a financial institution',
      'A financial market utility designated by the Financial Stability Oversight Council (FSOC)',
      'Registered with the Commodity Futures Trading Commission - Commodity Pool Operator',
      'Registered with the Commodity Futures Trading Commission - Commodity Trade Advisor',
      'Registered with the Commodity Futures Trading Commission - Retail foreign exchange dealer',
      'Registered with the Commodity Futures Trading Commission - Swap dealer or major swap participant registered with the Commodity Futures Trading Commission',
      'Non-Profit Corporation or Charity',
      'Pooled investment vehicle that is operated or advised by a financial institution which is NOT excluded under paragraph (e)(2) of 31 CFR 1010.230'
    ])
  };

  if (formState?.exemptionType?.startsWith('Publicly Traded')) {
    schema.tradingSymbol = t.String;
  }

  if (formState?.exemptionType === 'An insurance company regulated by a state') {
    schema.insuranceCompanyState = buildUsStateEnum({
      includeDC: true,
      includeTerritories: false
    });
  }

  let inputComponent = null;
  // if (!formState?.exemptionType) {
  //   inputComponent = RadioSelect;
  // }

  return (
    <div className="form-section">
      <HeaderText>
        Exemptions
      </HeaderText>
      <div>
        Some types of companies are not required to provide Beneficial Ownership Information
        per existing regulations.
        <br/><br/>
        If your company matches one of the exemptions below, you may select it
        in place of providing Beneficial Ownership information. If multiple exemptions apply,
        only one needs to be selected.
        <br /><br />
        If your company does not match any exemption, select <strong>No Exemption</strong>.
      </div>
      <FormJSX
        ref={ref}
        modelType={t.struct(schema)}
        value={formState}
        onChange={(v) => {
          setFormState(v);
          onChange(v);
        }}>

        <FieldOption name="exemptionType"
          label="Company Exemption"
          inputComponent={inputComponent} />

        <FieldOption name="tradingSymbol"
          label="Trading Symbol / Ticker Symbol"
          placeholder="e.g. AAPL" />

        <FieldOption name="insuranceCompanyState"
          label="What state regulates this company?" />

      </FormJSX>

    </div>
  );
}

export default forwardRef(ExemptionForm);